import VideoStory from './VideoStory';

export default class HomeHero {
	constructor(el) {
		this.el = el;

		this.videoStories = Array.from(this.el.querySelectorAll('[data-video-story]')).map(
			(story) => new VideoStory(story)
		);
	}

	destroy() {
		this.videoStories.forEach((videoStory) => videoStory.destroy());
	}
}
